import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { IconDefinition } from '@fortawesome/free-regular-svg-icons'

@Component({
  selector: 'app-tabs-static',
  template: `
    <nav class="tabs-static-wrapper standalone">
      <a *ngFor="let tab of tabs" class="tab-item shadow-sm" role="button" (click)="changeTab(tab.name)"
         [ngClass]="{ 'active': isActive(tab.name), 'disabled': tab.disabled }">
        <fa-icon *ngIf="tab.icon" [icon]="tab.icon"></fa-icon>
        <span>{{ tab.label | transloco }}</span>
      </a>
    </nav>
  `,
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsStaticComponent {
  @Input() tabs: { name: string; label: string, disabled?: boolean, icon?: IconDefinition }[] = [];
  @Input() activeTabName: string;
  @Output() tabChanged = new EventEmitter<string>();

  isActive(tabName: string) {
    return this.activeTabName === tabName;
  }

  changeTab(tabName: string) {
    if (this.tabs.some(tab => tab.name === tabName && !tab.disabled)) {
      this.activeTabName = tabName;
      this.tabChanged.next(tabName);
    }
  }
}
